import {
    FETCH_DATA_SEARCHERS_REQUEST,
    FETCH_DATA_SEARCHERS_SUCCESS,
    FETCH_DATA_SEARCHERS_FAILURE,
} from '../../actions/searchers/get-searchers-actions';

const initialState = {
    list: [],
    isLoading: false,
    error: null,
    meta: null
};

const SearchersReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_SEARCHERS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_SEARCHERS_SUCCESS:

        console.log(" action.payload.values",  action.payload.values);
            return {
                ...state,
                isLoading: false,
                list: action.payload.values,
                meta: action.payload.meta
            };
        case FETCH_DATA_SEARCHERS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default SearchersReducer;